import React, { createContext, useContext, useState, ReactNode } from "react";
import i18n from "../i18n";

interface I18nContextType {
  locale: string;
  setLocale: (locale: string) => void;
  t: (scope: string, options?: object) => string;
  isRTL: boolean;
}

const RTL_LOCALES = ["ar", "he", "fa", "ur"];

const I18nContext = createContext<I18nContextType | undefined>(undefined);

interface I18nProviderProps {
  children: ReactNode;
}

export const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const [locale, setLocaleState] = useState<string>(i18n.locale);

  const setLocale = (newLocale: string) => {
    i18n.locale = newLocale;
    setLocaleState(newLocale);
  };

  const t = (scope: string, options?: object): string => i18n.t(scope, options);

  const isRTL = RTL_LOCALES.includes(locale);

  return (
    <I18nContext.Provider value={{ locale, setLocale, t, isRTL }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = (): I18nContextType => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error("useTranslation must be used within an I18nProvider");
  }
  return context;
};
